var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SurfacePostsDraggablePad,{class:['flex', 'flex-col', 'items-center', 'space-y-8'],attrs:{"dir":_setup.dir}},[_vm._l((_setup.sortedGroups),function(group){return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_setup.shouldDisplayGroup(group)),expression:"shouldDisplayGroup(group)"}],key:group.id,class:[
      'flex',
      'flex-col',
      'w-full',
      'items-start tablet-portrait:items-center',
      {
        'surface-section': _setup.wishGroupBy === _setup.GroupByTypes.Section,
      },
      'relative',
    ],attrs:{"id":'section-' + group.id,"data-id":group.id,"data-rank":group.sort_index}},[(_setup.canShowDraggingOverlayOnGroup(group.id))?_c('div',{class:[
        'absolute -mt-4 z-underneath',
        'border-solid border-2 rounded-xl shadow-elevation-2',
        'pointer-events-none',
        {
          'border-grape-500 bg-modal-overlay-grape-alpha-20': _setup.backgroundLuminance === 'light',
          'border-canary-500 bg-modal-overlay-canary-alpha-20': _setup.backgroundLuminance === 'dark',
        },
      ],style:({ height: `${_setup.overlayHeight}px`, width: _setup.isSmallerThanTabletPortrait ? '100%' : `${_setup.overlayWidth}px` })}):_vm._e(),_vm._v(" "),(_setup.wishGroupBy === _setup.GroupByTypes.Section)?_c(_setup.SurfacePostGroupHeaderSection,{class:[
        // By design, this header max width is post width - 6px.
        // Since the parent sets align-items: center, we use
        // negative margin here to pull the header a bit to the
        // left (right in RTL).
        'tablet-portrait:-ms-1.5',
        'w-full',
        // On mobile viewport, the header extends all the way to
        // the left (right in RTL) so we need to subtract 8px
        // (equal to padding).
        _setup.isPostSizeStandard && 'tablet-portrait:max-w-[calc(540px-6px)] max-w-[calc(100%-6px-8px)]',
        _setup.isPostSizeWide && 'tablet-portrait:max-w-[calc(748px-6px)] max-w-[calc(100%-6px-24px)]',
      ],attrs:{"section":group}}):_vm._e(),_vm._v(" "),_c('div',{class:[
        'flex',
        'flex-col',
        'items-center',
        'space-y-2 tablet-portrait:space-y-4',
        'box-border',
        group.id === _setup.GroupByTypes.None ? 'mt-0' : 'mt-4',
        _setup.isPostSizeStandard && 'px-2 tablet-portrait:px-0',
        _setup.isPostSizeWide && 'px-2 tablet-portrait:px-6',
        'w-full',
        'group-posts',
      ],attrs:{"id":`group-posts-${group.id}`,"data-id":group.id}},[(_setup.isAppUsing('lazyRenderPosts'))?[_vm._l((_setup.allSortedPostsByGroup[group.id]),function(post){return [_c(_setup.SurfaceLazy,{directives:[{name:"show",rawName:"v-show",value:(_setup.shouldDisplayPost(post.cid)),expression:"shouldDisplayPost(post.cid)"}],key:post.cid,class:['wish-wrapper', 'w-full', 'flex', 'justify-center'],attrs:{"data-cid":post.cid,"data-id":post.id,"min-height":_setup.minHeight,"min-width":_setup.minWidth}},[_c(_setup.SurfacePost,{class:[
                // Exclude this component from using styles in app/assets/stylesheets/3/surface/show/layouts/stream.scss
                'wish-v2',
                'w-full',
                _setup.isPostSizeStandard && 'tablet-portrait:max-w-135',
                _setup.isPostSizeWide && 'tablet-portrait:max-w-187',
              ],attrs:{"index":post.id,"post":post,"post-reaction-ids":post.id ? _vm.reactionIdsByPostId[post.id] : [],"post-comment-ids":post.id ? _vm.commentIdsByPostId[post.id] : []}})],1)]})]:_vm._l((_setup.allSortedPostsByGroup[group.id]),function(post){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.shouldDisplayPost(post.cid)),expression:"shouldDisplayPost(post.cid)"}],key:post.cid,class:['wish-wrapper', 'w-full', 'flex', 'justify-center'],attrs:{"data-cid":post.cid,"data-id":post.id}},[_c(_setup.SurfacePost,{class:[
              // Exclude this component from using styles in app/assets/stylesheets/3/surface/show/layouts/stream.scss
              'wish-v2',
              'w-full',
              _setup.isPostSizeStandard && 'tablet-portrait:max-w-135',
              _setup.isPostSizeWide && 'tablet-portrait:max-w-187',
            ],attrs:{"post":post,"post-reaction-ids":post.id ? _vm.reactionIdsByPostId[post.id] : [],"post-comment-ids":post.id ? _vm.commentIdsByPostId[post.id] : []}})],1)})],2)],1)}),_vm._v(" "),_c('div',{key:"wish-sizer",staticClass:"wish-sizer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }